export const HA_CANCEL_FLEXIBILITY_FILTER_BAR = 'Cancel_Flexibility_Filter_Bar';
export const VRBO_WEB_SEARCH_NEW_FILTER_MENU =
    'VRBO_WEB_SEARCH_NEW_FILTER_MENU';
